import './achievements.scss';
import Logo from '../../assets/logo-small.svg';
import BADGE_LOCKED from '../../assets/badge-locked.png';
import TROPHY_FIRST from '../../assets/trophy-first.svg';
import TROPHY_SECOND from '../../assets/trophy-second.svg';
import TROPHY_THIRD from '../../assets/trophy-third.svg';
import { useNavigate } from "react-router-dom";
import { useState, useEffect } from 'react';
import Button from '../../components/button/button';
import FooterClient from '../../components/footer-client/footer-client';
import ModalCategoriesDetails from '../../components/modal-categories-details/modal-categories-details';
import ModalTeamAchievements from '../../components/modal-team-achievements/modal-team-achievements';
import ModalChallengeStats from '../../components/modal-challenge-stats/modal-challenge-stats';
import ModalBadge from '../../components/modal-badge/modal-badge';
import EmptyState from '../../components/empty-state/empty-state';
import AchievementsService from '../../services/achievements-service';
import UtilsService from '../../services/utils-service';
import LocalStorage from '../../services/local-storage';
import { TEAM, SESSION, ASSETS, CAMPAIGN_STATUS } from '../../constants';
import TranslateService from '../../services/translate-service';
import CampaignTabs from  '../../components/campaign-tabs/campaign-tabs'; 
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from 'chart.js';
import { Doughnut } from 'react-chartjs-2';

ChartJS.register(ArcElement, Tooltip, Legend);


export default function Achievements() {

    const navigate = useNavigate();

    const [team] = useState(LocalStorage.get(TEAM));
    const [session] = useState(LocalStorage.get(SESSION));

    const [chart, setChart] = useState({ totales: 0, perdidos: 0, ganados: 0 });
    const [efficacy, setEfficacy] = useState({ yo: 0, mejorQue: 0 });
    const [highlights, setHighlights] = useState({mejor: null, peor: null});
    const [teamAchievements, setTeamAchievements] = useState([]);
    const [morePlayed, setMorePlayed] = useState(null);
    const [moreWon, setMoreWon] = useState(null);
    const [moreLost, setMoreLost] = useState(null);
    const [badges, setBadges] = useState([]);
    const [categories, setCategories] = useState([]);

    const [modalCategories, setModalCategories] = useState(false);
    const [modalVS, setModalVS] = useState(false);
    const [modalDataVS, setModalDataVS] = useState();
    const [modalTeamAchievements, setModalTeamAchievements] = useState(false);
    const [modalBadge, setModalBadge] = useState(false);
    const [modalDataBadge, setModalDataBadge] = useState();

    const [campaign] = useState(LocalStorage.get(CAMPAIGN_STATUS));
    const [tabCampaignActive, setTabCampaignActive] = useState('campaign');


    const getCategories = async () => {
        const response = await AchievementsService.getCategories(team.area._id, session._id);
        setCategories(response);
    }
    const getChartData = async () => {
        const campaignID = tabCampaignActive === 'campaign' && campaign ? campaign._id: '';
        const response = await AchievementsService.getChartData(team.area._id, team._id, session._id, campaignID);
        setChart(response);
    }
    const getEfficacy = async () => {
        const campaignID = tabCampaignActive === 'campaign' && campaign ? campaign._id: '';
        const response = await AchievementsService.getEfficacy(team.area._id, team._id, session._id, campaignID);
        setEfficacy(response);
    }
    const getHighlights = async () => {
        const campaignID = tabCampaignActive === 'campaign' && campaign ? campaign._id: '';
        const response = await AchievementsService.getHighlights(team.area._id, team._id, session._id, campaignID);
        setHighlights(response);
    }
    const getTeamAchievements = async () => {
        const response = await AchievementsService.getTeamAchievements(team.area._id, team._id, session._id);
        setTeamAchievements(response);
    }
    const getMorePlayed = async () => {
        const campaignID = tabCampaignActive === 'campaign' && campaign ? campaign._id: '';
        const response = await AchievementsService.getMorePlayed(team.area._id, session._id, campaignID);
        setMorePlayed(response);
    }
    const getMoreWon = async () => {
        const campaignID = tabCampaignActive === 'campaign' && campaign ? campaign._id: '';
        const response = await AchievementsService.getMoreWon(team.area._id, session._id, campaignID);
        setMoreWon(response);
    }
    const getMoreLost = async () => {
        const campaignID = tabCampaignActive === 'campaign' && campaign ? campaign._id: '';
        const response = await AchievementsService.getMoreLost(team.area._id, session._id, campaignID);
        setMoreLost(response);
    }
    const getBadges = async () => {
        const response = await AchievementsService.getBadges(team.area._id, team._id, session._id);
        setBadges(response);
    }

    const openModalVS = async (title, data) => {
        const response = await AchievementsService.getVS(team.area._id, session._id, data.jugador._id);
        setModalDataVS({
            title,
            jugador: response.jugador,
            oponente: response.oponente,
        });
        setModalVS(true);
    }
    const openModalBadge = (badge) => {
        setModalDataBadge(badge);
        setModalBadge(true);
    }

    const formatBetterThan = () => {
        let text = TranslateService.get('stats.betterThan');

        text = text.replace('{accuracy}', efficacy.mejorQue);

        return text;
    }


    useEffect(() => {
        getBadges();
        getCategories();
        getTeamAchievements();
    }, []);

    useEffect(() => {
        setTabCampaignActive(campaign ? 'campaign': 'global')
    }, [campaign]);

    useEffect(() => {
        getChartData();
        getEfficacy();
        getHighlights();
        getMorePlayed();
        getMoreWon();
        getMoreLost();
    }, [tabCampaignActive]);

    return (
        <>
            <ModalCategoriesDetails isOpen={modalCategories} categories={categories} onClose={() => setModalCategories(false)} />
            <ModalTeamAchievements isOpen={modalTeamAchievements} teamAchievements={teamAchievements} onClose={() => setModalTeamAchievements(false)} />
            <ModalChallengeStats isOpen={modalVS} data={modalDataVS} onClose={() => setModalVS(false)} />
            <ModalBadge isOpen={modalBadge} badge={modalDataBadge} onClose={() => setModalBadge(false)} />

            <div className='achievements'>

                <div className="pb-16 ">

                    <div className='container  mx-auto px-4'>

                        <div className='flex items-center w-full pt-11 pb-5'>
                            <div className='flex items-center '>
                                <img src={Logo} alt="" />
                            </div>
                        </div>


                        <div className='grid gap-[16px] grid-cols-12'>
                            <div className='col-span-10 col-start-2'>
                                <div className=''>
                                    <Button className='link !text-[#000000] !font-normal' onClick={() => navigate(-1)}>{TranslateService.get('stats.back.btn')}</Button>
                                </div>

                                <div className='text-center mt-7'>
                                    <CampaignTabs active={tabCampaignActive} setTab={(tab) => setTabCampaignActive(tab)}/>
                                </div>

                                <div className='text-center mt-7 mb-7'>
                                    <h1 className='heading-h2'>{TranslateService.get('stats.title')}</h1>
                                    <p className='heading-h6 uppercase mt-3' dangerouslySetInnerHTML={{ __html: formatBetterThan() }} ></p>
                                </div>

                                <div className='grid gap-[16px] grid-cols-12   mt-5'>
                                    <div className='col-span-5'>
                                        <div className='card h-full'>
                                            <div className='heading-h6 uppercase pb-5 separator-bottom'>
                                                📈 {TranslateService.get('stats.stats.title')}
                                            </div>

                                            {!highlights.mejor && !highlights.peor && !morePlayed && !moreWon && !moreLost &&
                                                <EmptyState title={TranslateService.get('stats.emptyState.title')} description={TranslateService.get('stats.emptyState.description')} />
                                            }

                                            {highlights.mejor && highlights.peor && 
                                                <>
                                                <div className='flex mt-4 mb-7'>
                                                    <p className='grow'>{TranslateService.get('stats.categories.title')}</p>
                                                    <Button className='link !uppercase' onClick={() => setModalCategories(true)}>{TranslateService.get('stats.categories.detailsLink')}</Button>
                                                </div>
                                                <div className='flex justify-center mb-7'>
                                                    
                                                    <div className=''>
                                                        <div className='rounded-full m-auto'>
                                                            <img src={`${ASSETS.ICONS_CATEGORIES}${highlights.mejor.icono}`} alt='' className='rounded-full m-auto w-[48px] h-[48px]' />
                                                        </div>
                                                        <div className='text-center mt-3'>
                                                            <p className='truncate'>{highlights.mejor.nombre}</p>
                                                            <p className='truncate text-secundary text-[12px]'>{TranslateService.get('stats.categories.best')}</p>
                                                        </div>
                                                    </div>
                                                    <div className='ml-8'>
                                                        <div className='rounded-full m-auto'>
                                                            <img src={`${ASSETS.ICONS_CATEGORIES}${highlights.peor.icono}`} alt='' className='rounded-full m-auto w-[48px] h-[48px]' />
                                                        </div>
                                                        <div className='text-center mt-3'>
                                                            <p className='truncate'>{highlights.peor.nombre}</p>
                                                            <p className='truncate text-secundary text-[12px]'>{TranslateService.get('stats.categories.worst')}</p>
                                                        </div>
                                                    </div>
                                                        
                                                </div>
                                                </>
                                            }


                                            {(morePlayed || moreWon || moreLost) &&
                                            <>
                                                <div className='mb-7 mt-4 '>
                                                    <p className='grow'>{TranslateService.get('stats.challenges.title')}</p>
                                                </div>
                                                <div className='flex justify-evenly mb-3'>

                                                    {morePlayed &&
                                                        <div className=''>
                                                            <div className='rounded-full avatar-pink m-auto'>
                                                                <img src={`${ASSETS.AVATAR_PLAYER}${morePlayed.jugador.avatar}`} alt='' className='rounded-full m-auto w-[48px]' />
                                                            </div>
                                                            <div className='text-center mt-3'>
                                                                <p className='truncate text-heading-default text-[12px]'>{UtilsService.formatPlayerName(morePlayed.jugador.nombre, morePlayed.jugador.apellidoPaterno)}</p>
                                                                <p className='truncate text-secundary text-[12px]'>{TranslateService.get('stats.challenges.morePlayed')}</p>
                                                                <Button className='link !uppercase mt-2 !text-[10px]' onClick={() => openModalVS(TranslateService.get('stats.modal.challenge.title.played'), morePlayed)}>{TranslateService.get('stats.challenges.link')}</Button>
                                                            </div>
                                                        </div>
                                                    }
                                                    {moreWon &&
                                                        <div className=''>
                                                            <div className='rounded-full avatar-pink m-auto'>
                                                                <img src={`${ASSETS.AVATAR_PLAYER}${moreWon.jugador.avatar}`} alt='' className='rounded-full m-auto w-[48px]' />
                                                            </div>
                                                            <div className='text-center mt-3'>
                                                                <p className='truncate text-heading-default text-[12px]'>{UtilsService.formatPlayerName(moreWon.jugador.nombre, moreWon.jugador.apellidoPaterno)}</p>
                                                                <p className='truncate text-secundary text-[12px]'>{TranslateService.get('stats.challenges.moreWon')}</p>
                                                                <Button className='link !uppercase mt-2 !text-[10px]' onClick={() => openModalVS(TranslateService.get('stats.modal.challenge.title.won'), moreWon)}>{TranslateService.get('stats.challenges.link')}</Button>
                                                            </div>
                                                        </div>
                                                    }
                                                    {moreLost &&
                                                        <div className=''>
                                                            <div className='rounded-full avatar-pink m-auto'>
                                                                <img src={`${ASSETS.AVATAR_PLAYER}${moreLost.jugador.avatar}`} alt='' className='rounded-full m-auto w-[48px]' />
                                                            </div>
                                                            <div className='text-center mt-3'>
                                                                <p className='truncate text-heading-default text-[12px]'>{UtilsService.formatPlayerName(moreLost.jugador.nombre, moreLost.jugador.apellidoPaterno)}</p>
                                                                <p className='truncate text-secundary text-[12px]'>{TranslateService.get('stats.challenges.moreLost')}</p>
                                                                <Button className='link !uppercase mt-2 !text-[10px]' onClick={() => openModalVS(TranslateService.get('stats.modal.challenge.title.lost'), moreLost)}>{TranslateService.get('stats.challenges.link')}</Button>
                                                            </div>
                                                        </div>
                                                    }
                                                </div>
                                            </>
                                            }
                                           
                                        </div>

                                    </div>
                                    <div className='col-span-7 '>

                                        <div className='card h-full'>
                                            <div className='heading-h6 uppercase pb-5 separator-bottom'>
                                                🌤️ {TranslateService.get('stats.chart.title')}
                                            </div>

                                            <div className='grid gap-[16px] grid-cols-12 items-center h-[90%]'>
                                                {chart.totales === 0 &&
                                                    <div className='col-span-12'>
                                                        <EmptyState title={TranslateService.get('stats.emptyState.title')} description={TranslateService.get('stats.emptyState.description')} />
                                                    </div>
                                                }

                                                {chart.totales !== 0 &&
                                                    <>
                                                        <div className='col-span-6'>
                                                            <div className='p-10 relative min-h-[300px]'>
                                                                <Doughnut className='chart-title' width={'80%'} height={'80%'} data={{
                                                                    datasets: [
                                                                        {
                                                                            label: 'Stats',
                                                                            data: [chart.ganados, chart.perdidos],
                                                                            backgroundColor: () => {
                                                                                let ctx = document.createElement('canvas').getContext("2d")
                                                                                var gradient = ctx.createLinearGradient(0, 0, 300, 0)
                                                                                gradient.addColorStop(0.29, '#BC3F8D')
                                                                                gradient.addColorStop(0.57, '#791FA0')

                                                                                return [gradient, '#E5E8FF']
                                                                            },
                                                                            borderWidth: 0,
                                                                            cutout: '80%',
                                                                            spacing: 10,
                                                                            borderRadius: 10,
                                                                            rotation: 125,
                                                                        }
                                                                    ]
                                                                }
                                                                }

                                                                    options={
                                                                        {
                                                                            // responsive: true,
                                                                            plugins: {
                                                                                legend: {
                                                                                    display: false,
                                                                                },
                                                                                title: {
                                                                                    display: false
                                                                                },
                                                                                tooltip: {
                                                                                    backgroundColor: '#ffffff',
                                                                                    bodyColor: '#000000',
                                                                                    padding: 16,
                                                                                    cornerRadius: 4,
                                                                                    caretSize: 0,
                                                                                    bodyFont: {
                                                                                        size: 14,
                                                                                        family: 'Montserrat',
                                                                                        weight: '600'
                                                                                    },
                                                                                    displayColors: false,
                                                                                    callbacks: {
                                                                                        label: (ctx) => {
                                                                                            let porcentaje = 0;

                                                                                            if (chart.totales > 0) {
                                                                                                porcentaje = (ctx.raw * 100) / chart.totales;
                                                                                            }

                                                                                            return `${UtilsService.round(porcentaje)}%`
                                                                                        }
                                                                                    }
                                                                                }
                                                                            }
                                                                        }
                                                                    }
                                                                />

                                                                <div className='text-center chart-title'>
                                                                    <h1 className='heading-h5'>{UtilsService.format(chart.totales)}</h1>
                                                                    <p className='text-secundary text-[12px]'>{TranslateService.get('stats.chart.answers')}</p>
                                                                </div>

                                                            </div>
                                                        </div>
                                                        <div className='col-span-6'>
                                                            <div className='mini-card'>
                                                                <div className='right-answers'></div>
                                                                <div>
                                                                    <p className='heading-h6'>{UtilsService.format(chart.ganados)}</p>
                                                                    <p className='text-secundary text-sm'>{TranslateService.get('stats.chart.right')}</p>
                                                                </div>
                                                            </div>
                                                            <div className='mini-card mt-5'>
                                                                <div className='wrong-answers'></div>
                                                                <div>
                                                                    <p className='heading-h6'>{UtilsService.format(chart.perdidos)}</p>
                                                                    <p className='text-secundary text-sm'>{TranslateService.get('stats.chart.wrong')}</p>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </>
                                                }

                                            </div>
                                        </div>

                                    </div>

                                </div>


                                <div className='grid gap-[16px] grid-cols-12  mt-[32px]'>
                                    <div className='col-span-12'>
                                        <div className='card '>
                                            <div className='heading-h6 uppercase pb-5 separator-bottom'>
                                                🎊 {TranslateService.get('stats.teams.title')} ({teamAchievements.length})
                                                {teamAchievements.length > 6 && <Button className='link !uppercase float-right' onClick={() => setModalTeamAchievements(true)}>{TranslateService.get('stats.teams.detailsLink')}</Button>}

                                            </div>

                                            <div className='grid gap-x-[16px] gap-y-[24px] grid-cols-12  mt-[32px]'>
                                                {!teamAchievements.length &&
                                                    <div className='col-span-12'>
                                                        <EmptyState title={TranslateService.get('stats.emptyState.title')} description={TranslateService.get('stats.emptyState.description')} />
                                                    </div>
                                                }
                                                {
                                                    teamAchievements.slice(0, 6).map((t, index) => (
                                                        <div className='col-span-6' key={index}>
                                                            <div>
                                                                <div className='flex items-center'>
                                                                    {t.posicion === 1 && <div className='badge-icon mx-auto' style={{ backgroundImage: `url("${TROPHY_FIRST}")` }}></div>}
                                                                    {t.posicion === 2 && <div className='badge-icon mx-auto' style={{ backgroundImage: `url("${TROPHY_SECOND}")` }}></div>}
                                                                    {t.posicion === 3 && <div className='badge-icon mx-auto' style={{ backgroundImage: `url("${TROPHY_THIRD}")` }}></div>}
                                                                    <div className='grow ml-[11px]'>
                                                                        <p className=''>{t.nombre}</p>
                                                                        <p className='text-secundary text-sm'>{TranslateService.get('stats.teams.won')} {UtilsService.formatDate(t.fecha)}</p>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    ))
                                                }

                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className='grid gap-[16px] grid-cols-12  mt-[32px]'>
                                    <div className='col-span-12'>
                                        <div className='card '>
                                            <div className='heading-h6 uppercase pb-5 separator-bottom'>
                                                🎖️ {TranslateService.get('stats.badges.title')} ({badges.filter(b => b.conseguida).length}/{badges.length})
                                            </div>

                                            <div className='grid gap-[16px] grid-cols-12  mt-[32px]'>
                                                {
                                                    badges.map(b => (
                                                        <div className='col-span-2' key={b._id} onClick={() => openModalBadge(b)}>
                                                            <div className='badges text-center'>
                                                                <div className='badge-icon mx-auto' style={{ backgroundImage: `url("${(b.conseguida ? `${ASSETS.ICONS_ACHIEVEMENTS}${b.icono}` : BADGE_LOCKED)}")` }}></div>
                                                                <p className='mt-[10px]'>{b.nombre}</p>
                                                            </div>
                                                        </div>
                                                    ))
                                                }

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <FooterClient />
                    </div>
                </div>

            </div>
        </>
    )

}